export default __webpack_public_path__ + "static/media/signin-background.ded567f8.svg";